export enum InvestigationSessionType {
	InPerson = 1,
	Video = 2,
	Written = 3,
}
